import React from 'react';
import styled from 'styled-components';

import Color from '@styles/Color';
import CloseBtn from '@components/dataEntry/button/CloseBtn/CloseBtn';
import useWindowWidth from '@hooks/useWindowWidth';

const ActionBarHeaderWrap = styled.div`
  background-color: ${Color.BLUE_GRAY_8};
  color: ${Color.BLUE_GRAY_1};
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;

  span {
    width: 100%;
  }
`;

type Props = {
  text: string;
  close: () => void;
};
function ActionBarHeader({ text, close }: Props) {
  const isMobile = useWindowWidth() < 480;

  if (!isMobile) return null;

  return (
    <ActionBarHeaderWrap>
      <CloseBtn shape="default" onClick={close} color={Color.BLUE_GRAY_1} />
      {text}
    </ActionBarHeaderWrap>
  );
}

export default ActionBarHeader;
